export default {
  hasDOM() {
    return typeof document !== 'undefined'
  },
}
